module.exports = __webpack_public_path__ + "media/images/emoticons/foot-9404a296026dfd408dbf9c89d58304f2.gif";